import { render, staticRenderFns } from "./OperationsDashboard.vue?vue&type=template&id=3ba612e4&scoped=true&"
import script from "./OperationsDashboard.vue?vue&type=script&lang=js&"
export * from "./OperationsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OperationsDashboard.vue?vue&type=style&index=0&id=3ba612e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba612e4",
  null
  
)

export default component.exports